export const END_OF_TERM = 'end-of-term'
export const DIRECTLY = 'directly'
